<script setup>
/**
 * Botão "?" com a explicação do indicador. O texto vem do dicionário
 * CRM_METRICS, o mesmo em todas as telas de relatório.
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  metricKey: { type: String, required: true },
});

const { t } = useI18n();
const help = computed(() => t(`CRM_METRICS.${props.metricKey}.HELP`));
</script>

<template>
  <button
    v-tooltip.top="help"
    type="button"
    class="cursor-help rounded text-n-slate-9 focus:outline-none focus-visible:ring-2 focus-visible:ring-n-blue-8"
    :aria-label="help"
  >
    <span class="i-lucide-circle-help block text-sm" />
  </button>
</template>
